import consumerApi from "api/services/consumer-api";
import { DeliveryServiceAreaInfo } from "custom-types/Dispensary";
import logError from "utils/logError";

type DeliveryServiceAreaResponse = {
  userInDeliveryServiceArea: boolean;
  deliveryServiceArea: DeliveryServiceAreaInfo | Record<string, never>;
};

export const getDeliveryServiceArea = async ({
  countryCode,
  lat,
  lon,
  dispensaryId,
}: {
  countryCode: string;
  lat: number;
  lon: number;
  dispensaryId: number;
}): Promise<DeliveryServiceAreaResponse | undefined> => {
  try {
    const { data } = await consumerApi.get(
      "/api/finder/v1/delivery-service-area",
      {
        headers: {
          "x-country-code": countryCode,
        },
        params: { dispensary_id: dispensaryId, lat, lon },
      },
    );

    return data;
  } catch (error) {
    logError(error.message, {
      functionName: "getDeliveryServiceArea",
      service: "consumer",
      statusCode: error.statusCode,
    });
  }
};
